import { InjectionToken } from '@angular/core';
import { TimeZoneConfigService } from './time-zone.config.service';

export const TIMEZONE_CONFIG_TOKEN = new InjectionToken<TimeZoneConfig>(
  'TIMEZONE_CONFIG_TOKEN',
);

export function timeZoneInitializerFactory(
  timeZoneConfigService: TimeZoneConfigService,
  timeZoneConfig: TimeZoneConfig,
): () => Promise<void> {
  const promise = timeZoneConfigService.init(timeZoneConfig).then((value) => {
    console.log('timeZoneId', timeZoneConfigService.get());
  });
  return () => promise;
}

export declare type TimeZoneConfig = {
  timeZoneId: string;
};
